import { client } from '@/api/generated/client.gen';
import * as api from '@/api/generated';
import { getAuth } from 'firebase/auth';

client.interceptors.request.use(async (request, _options) => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (user) {
    // getIdToken() automatically refreshes the token if it's expired
    const accessToken = await user.getIdToken();
    request.headers.set('X-Auth-Token', accessToken);

    // Handle impersonation if needed
    const impersonateUserId = localStorage.getItem('auth.impersonate');
    if (impersonateUserId) {
      request.headers.set('X-Impersonate', impersonateUserId);
    }
  }

  return request;
});

export function useApiClient() {
  return {
    // TODO: doesn't this make tree shaking impossible?
    api,
  };
}
